import { TrackingEvents } from "./trackingEvents";
import trackingService from "./trackingService";

const STORAGE_PREFIX = "ph_auth_account_created:";
export const ACCOUNT_CREATION_WINDOW_MS = 5 * 60 * 1000;
const ALLOWED_FUTURE_CLOCK_SKEW_MS = 60 * 1000;

export type AuthAccountCreationMethod = "email_otp" | "google_sso";

const hasAlreadyTracked = (userId: string): boolean => {
  try {
    return window.localStorage.getItem(`${STORAGE_PREFIX}${userId}`) === "true";
  } catch {
    return false;
  }
};

const markTracked = (userId: string): void => {
  try {
    window.localStorage.setItem(`${STORAGE_PREFIX}${userId}`, "true");
  } catch {
    // Analytics must never break authentication if storage is unavailable.
  }
};

export function trackAccountCreatedIfRecent(params: {
  userId: string | null | undefined;
  createdAt: Date | string | null | undefined;
  method: AuthAccountCreationMethod;
  nowMs?: number;
}): boolean {
  if (!params.userId || !params.createdAt || hasAlreadyTracked(params.userId)) return false;

  const createdAtMs = new Date(params.createdAt).getTime();
  if (!Number.isFinite(createdAtMs)) return false;

  const ageMs = (params.nowMs ?? Date.now()) - createdAtMs;
  if (ageMs < -ALLOWED_FUTURE_CLOCK_SKEW_MS || ageMs > ACCOUNT_CREATION_WINDOW_MS) {
    return false;
  }

  trackingService.track(TrackingEvents.AUTH_ACCOUNT_CREATED, {
    method: params.method,
    detection_method: "created_at_window",
  });
  markTracked(params.userId);
  return true;
}
